"use client"

import { useState } from "react"
import "./AIFaq.css"

const faqData = [
  {
    question: "How can our Data Sientists help you?",
    answer:
      "Data Science can be used for:• Detection of anomalies (fraud, disease, crime)• Automation and decision-making (background checks, creditworthiness)• Classifications (like classifying emails as “important” or “junk”)• Forecasting (sales, revenue and customer retention)• Pattern detection (weather patterns, financial market patterns)• Recognition (facial, object, voice, text, fingerprint)• Recommendations (products, services, books)",
  },
  {
    question: "How does our Data Science process works?",
    answer:
      "We follow a technology-agnostic process, designing AI systems through incremental development and continuous value delivery using a Scrum-based methodology. Our process has 4 main stages: Research, Ideation, Execution and Technical Assessment.",
  },
  {
    question: "How much does it cost to build a Data Science Solution?",
    answer:
      "The cost of a Data Science solution starts at $33 000*.If you need more detailed information, you can reach out to us, and we will help you with estimations. Our data scientists will support you on your journey to success by helping you achieve your business goals.*Note: Rates may vary based on currency.",
  },
  {
    question:
      "How long does it take to build a Data Science Solution?",
    answer:
      "or early-stage products, it takes 1,5 to 3 months to build a complete Data Science solution.",
  },
  {
    question: "Does Data Science require coding?",
    answer:
      "Data science requires tremendous work with machine learning models, which is only possible through programming and coding languages. Finding alternatives for such powerful machine learning packages might be challenging without at least some familiarity with languages. Hence, data scientists need to code to use their machine-learning libraries.",
  },
  {
    question: "What is the difference between Artificial Intelligence and Machine Learning??",
    answer:
      "In the computer science field, there is a correlation between artificial intelligence and machine learning. These two technologies are the most popular ones used to build intelligent systems today.Even though AI and ML are connected and occasionally used interchangeably, they are nonetheless two distinct concepts in various contexts. Broadly speaking, we can distinguish between AI and ML by saying:AI is a bigger concept to create intelligent machines that can simulate human thinking capability and behaviour, whereas, machine learning is an application or subset of AI that allows machines to learn from data without being programmed explicitly.",
  },
  {
    question:
      "What industries benefit the most from Artificial Intelligence and Data Science?",
    answer:
      "We serve industries such as finance, healthcare, e-commerce, manufacturing, logistics, and others, leveraging data-driven insights and AI-powered solutions to optimise operations and enhance customer experiences Read also:• Artificial Intelligence in business: a guide for industries",
  },
 
 
]

const FAQSection = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section5155">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">DATA SCIENCE SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default FAQSection
